import useSWR from "swr";
import { getUser, safeParseList } from "helpers";

import DealerService from "services/DealerService";
import UserService from "services/UserService";

const FILTER_DEALERS = 1;

const fetchDealers = async (
    dealerUserId,
    sdlid,
    dlid,
    subscriptionPlanId,
    page,
    limit,
    search = "",
    lite = false,
    isActive = ""
) => {
    let managedDomains = "";
    let isMultiDomain = false;

    if (dealerUserId) {
        const userResponse = await UserService.get(dealerUserId);

        if (userResponse?.data?.managedDomains) {
            const parsed = safeParseList(userResponse.data.managedDomains);
            if (parsed.length > 0) {
                managedDomains = parsed.join(",");
                isMultiDomain = true;
            }
        }

    }

    const parsedDlid = sdlid === FILTER_DEALERS ? dlid : "";
    const dealerResponse = await DealerService.getAll(
        parsedDlid,
        managedDomains,
        subscriptionPlanId,
        page,
        limit,
        search,
        lite,
        isActive
    );

    return {
        dealers: dealerResponse.data,
        isMultiDomain,
    };
};

const EMPTY_DEALERS = [];

const useDealers = (subscriptionPlanId, page, limit, search = "", lite = false, isActive = "") => {
    const sdlid = parseInt(localStorage.getItem("_sdlid"));
    const dlid = parseInt(localStorage.getItem("_dlid"));
    const { id: dealerUserId } = getUser(sdlid) || {};

    const shouldFetch = !!dealerUserId;

    const { data, error, isLoading } = useSWR(
        shouldFetch
            ? ["dealers", dealerUserId, sdlid, dlid, subscriptionPlanId, page, limit, search, lite, isActive]
            : null,
        () => fetchDealers(dealerUserId, sdlid, dlid, subscriptionPlanId, page, limit, search, lite, isActive),
        { revalidateOnFocus: false }
    );

    return {
        dealers: data?.dealers || EMPTY_DEALERS,
        totalCount: data?.dealers?.total || 0,
        isMultiDomain: data?.isMultiDomain || false,
        isLoading,
        isError: !!error,
    };
};

export default useDealers;
